import PropTypes from 'prop-types';
import { InputDescription, InputTitle } from 'components/atoms/styleds';
import RadioButtons from 'components/atoms/RadioButtons';
import { CostRelationView } from 'components/molecules/settings/relation-views';

import { ConfigBlock } from '../../styled';

const CostsForDelivery = ({ onChange, data }) => {
  const items = [
    {
      id: 'fixed',
      value: 'fixed',
      label: 'Fisso',
      description:
        'Indica un costo fisso che sarà applicato a tutte le consegne che effettuerai.',
      relationView: <CostRelationView data={data} onChange={onChange} />,
    },
    {
      id: 2,
      value: 'per_kilometer',
      label: 'Costo al chilometro',
      description:
        'Il valore verrà calcolato in base al percorso indicato da Google Maps.',
      relationView: <CostRelationView data={data} onChange={onChange} />,
    },
    {
      id: 3,
      value: 'fixed_or_per_kilometer',
      label: 'Fisso o costo al chilometro',
      description:
        'Indica la presenza di un costo fisso entro una determinata area o un costo al chilometro fuori dall’area.',
      relationView: <CostRelationView data={data} onChange={onChange} />,
    },
    {
      id: 4,
      value: 'fixed_plus_fixed',
      label: 'Fisso + fisso',
      description:
        'Indica la presenza di due costi fissi a seconda dell’area servita (esempio città, provincia).',
      relationView: <CostRelationView data={data} onChange={onChange} />,
    },
  ];

  return (
    <ConfigBlock showBorder={true}>
      <InputTitle>Costo per servizio di delivery</InputTitle>
      <InputDescription>
        Scegli uno dei quattro metodi per determinare il costo di consegna.
      </InputDescription>
      <RadioButtons
        name='delivery_cost_type'
        items={items}
        selected={data.delivery_cost_type}
        onChange={onChange}
      />
    </ConfigBlock>
  );
};

CostsForDelivery.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.shape({}),
};

export default CostsForDelivery;
